export default __webpack_public_path__ + "static/media/toast-warning.b9e9f9ce.svg";